<template>
  <span class="rqa_pill" :class="'rqa_pill_' + shown">{{ label }}</span>
</template>
<script>
import { STATUS_LABELS } from '@/store/modules/recruiterQa'

const SUPERSEDED_LABEL = 'הוחלף'

export default {
  name: 'RecruiterQaStatusPill',
  props: {
    status: { type: String, default: '' },
    // Supervisor view: 'superseded' shows as a muted "הוחלף". Recruiter callers
    // resolve it first (recruiterTurnStatus / recruiterTicketStatus); an
    // unresolved one falls back to failed (no known pending refresh).
    supervisor: { type: Boolean, default: false }
  },
  computed: {
    shown () {
      if (this.status !== 'superseded') return this.status
      return this.supervisor ? 'superseded' : 'failed'
    },
    label () {
      if (this.shown === 'superseded') return SUPERSEDED_LABEL
      return STATUS_LABELS[this.shown] || this.shown
    }
  }
}
</script>
<style scoped>
.rqa_pill {
  display: inline-block;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
  line-height: 18px;
  white-space: nowrap;
  background-color: #eee;
  color: #444;
}
.rqa_pill_running, .rqa_pill_consulting { background-color: #e8f0fe; color: #1a4fa0; }
.rqa_pill_answered { background-color: #e3f6ec; color: #1d6b43; }
.rqa_pill_needs_input { background-color: #fff3d6; color: #7a5b00; }
.rqa_pill_needs_human { background-color: #f1e8fb; color: #5a2d91; }
.rqa_pill_superseded { background-color: #f2f2f2; color: #888; }
.rqa_pill_failed { background-color: #fde8e7; color: #a12620; }
</style>
